// Keept Runner's one mark: three squares. Drawn in SVG, so it is crisp at any size: three rounded squares
// in a row, in the panel's blue — full, then lighter, then lightest. Flat fills, no gradients. Two states,
// and nothing else:
//   working   while the AI works the squares turn one after another, 1 → 2 → 3 (a flip on the
//             vertical axis, a full turn, so the loop has no seam)
//   idle      otherwise the mark only dims — it never moves
// A third use, `typing`, is the small mark by the command bar: it animates only while she types
// (a soft pulse 1 → 2 → 3), and is a still, dim mark the rest of the time. With reduced motion
// the turning is a gentle brightening instead.

export type MarkState = "idle" | "working" | "typing";

export const MARK_COLORS = ["#2F4BDE", "#7C8FEB", "#C2CCF7"] as const;

export function Mark({ state = "idle", size = 28, className = "", label = "Keept Runner" }: { state?: MarkState; size?: number; className?: string; label?: string }) {
  const h = size, w = Math.round(size * 2.6);
  return (
    <svg className={`kr-mark ${state} ${className}`} width={w} height={h} viewBox="0 0 78 30" role="img" aria-label={state === "working" ? `${label}, working` : label}>
      <g className="kr-sq s1" style={{ transformOrigin: "15px 15px" }}><rect x="2" y="2" width="26" height="26" rx="7" fill={MARK_COLORS[0]} /></g>
      <g className="kr-sq s2" style={{ transformOrigin: "39px 15px" }}><rect x="26" y="2" width="26" height="26" rx="7" fill={MARK_COLORS[1]} /></g>
      <g className="kr-sq s3" style={{ transformOrigin: "63px 15px" }}><rect x="50" y="2" width="26" height="26" rx="7" fill={MARK_COLORS[2]} /></g>
    </svg>
  );
}

/** The one loading screen, from starting the app to the desk: the three squares turning, centered on the panel's ground.
 *  The words are for screen readers only, so every step of loading looks the same and nothing jumps between them. */
export function BrandLoading({ label = "Loading Keept Runner" }: { label?: string }) {
  return <div className="loading-screen runner-loading" role="status"><Mark state="working" size={22} label={label} /></div>;
}

/** The mark as a data URL, for the browser tab while Keept Runner is open. */
export const MARK_ICON = "data:image/svg+xml," + encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78 30"><rect width="78" height="30" rx="8" fill="#ffffff"/><rect x="4" y="4" width="22" height="22" rx="6" fill="${MARK_COLORS[0]}"/><rect x="28" y="4" width="22" height="22" rx="6" fill="${MARK_COLORS[1]}"/><rect x="52" y="4" width="22" height="22" rx="6" fill="${MARK_COLORS[2]}"/></svg>`,
);
